module.exports = __webpack_public_path__ + "static/media/next.748953b7.mp3";